import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'reactstrap';
import IsnIntegrationBox from '../../shared/IsnIntegration';
import Button from '../../shared/Button';
import Checkbox from '../../shared/Checkbox';
import classNames from 'classnames';
import styles from './styles.scss';

class IsnIntegration extends React.Component {
  constructor(props) {
    super(props);
  }

  static get propTypes() {
    return {
      canEdit: PropTypes.bool,
      test: PropTypes.object,
      onFieldChange: PropTypes.func,
      onIsnGetData: PropTypes.func,
      isDataCollecting: PropTypes.bool,
      company: PropTypes.object,
      disabled: PropTypes.bool,
    };
  }

  render() {
    const { canEdit, test, onFieldChange, onIsnGetData, isDataCollecting, disabled } = this.props;
    const sideContent = (
      <Col md={12}>
        <div className={styles.isnCheckbox}>
          <Checkbox
            disabled={true}
            checked={test.isIsn}
            onChange={(value) => {
              canEdit ? onFieldChange('isIsn', value) : {};
            }}
          />
          <span
            onClick={() => {
              canEdit ? onFieldChange('isIsn', !test.isIsn) : {};
            }}
            className={classNames(styles.disabled, 'font-weight-bold')}
          >
            Sync Test with ISN
          </span>
        </div>
        <div className={styles.info}>
          Fields with green labels are pulling data from Order in ISN and are read-only in this application. To update
          this data, you must update in ISN and then click <b className={styles.bold}>Refresh</b> button below to
          populate to the Radon Management Cloud.
        </div>
      </Col>
    );

    const refreshDisabled = disabled || !test.isIsn || (test.company && !test.company.isIsn);

    return (
      <IsnIntegrationBox sideContent={sideContent}>
        <Col md={12} className={styles.isnData}>
          <div className={styles.label}>
            ISN Test ID<div className={styles.value}>{test.isnTestDisplayOid}</div>
          </div>
          <div className={styles.button}>
            <Button
              disabled={isDataCollecting || refreshDisabled}
              key="save"
              kind={!refreshDisabled ? 'green' : 'gray'}
              onClick={!refreshDisabled ? onIsnGetData : () => {}}
            >
              {isDataCollecting ? <i className="fa fa-spin fa-spinner" /> : 'Refresh'}
            </Button>
          </div>
        </Col>
      </IsnIntegrationBox>
    );
  }
}
export default IsnIntegration;



// WEBPACK FOOTER //
// src/components/testDetails/IsnIntegration/index.jsx